// extracted by mini-css-extract-plugin
export var resizer = "_ch-0";